import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ImageQueryService {
	transform(
		src: string,
		params: {
			width: number;
			height: number;
			transform?: 'fill' | 'fit';
			quality?: number;
		},
	): string {
		if (!src) {
			return '';
		}

		const transformMode = params.transform ?? 'fill';
		const quality = params.quality ?? 70;

		if (src.includes('assets.vandervalkonline.com')) {
			return `${src}&w=${params.width}&h=${params.height}&fmt=webp`;
		}
		return `${src}?io=transform:${transformMode},width:${params.width},height:${params.height}&format=webp&quality=${quality}`;
	}
}
